

export function getNode(node, name) {
    return node?.getElementsByTagName(name) && node?.getElementsByTagName(name)[0]
}

export function getArray(node, name) {
    return node?.children?.find(it => it.name === name)?.children
}

export function getArray2(node, name) {
    return node?.children?.filter(it => it.name === name)
}

export function getDescription(node) {
    // todo: lang -> but it is always (?) de in the data
    return node?.['ct:description']?.text
}

export function getHelp(node) {
    // todo: lang -> but it is always (?) de in the data
    return node?.['ct:description']?.['help']
}

export function dec2bin(dec) {
    return (dec >>> 0).toString(2);
}

